export const formatDateHelperFn = (dateString) => {
    const [day, month, year] = dateString.split("/");
    const date = new Date(`${year}-${month}-${day}`);
    const shortMonth = date.toLocaleString("en-US", { month: "short" });
    return `${day}-${shortMonth}-${year.slice(-2)}`;

};


export const toTitleCase = (str) => {
    return str
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};

// Event booking type codes vary in format across APIs ("EVENT-PARTY_HELPER",
// "EVENTS_PARTY_HELPER", ...), so match/label them by the package suffix
// instead of the exact string.
const EVENT_TYPE_PREFIX = /^EVENTS?[-_]/;

const EVENT_TYPE_LABELS = {
    STARTER: 'Starter DIY Package',
    DELUX: 'Deluxe Custom Packages',
    SIGNATURE: 'Signature Curated Packages',
    PARTY_HELPER: 'Party Helpers',
};

export const isEventServiceType = (type) =>
    typeof type === 'string' && EVENT_TYPE_PREFIX.test(type);

export const eventTypeLabel = (type) =>
    isEventServiceType(type)
        ? EVENT_TYPE_LABELS[type.replace(EVENT_TYPE_PREFIX, '')] || type
        : undefined;